<template src="./index.html">
</template>
<script>
	import minhead from '../../../../common/minHead/index.vue'
	import {getdata} from './data.js'
  import {
    jxzc_clearFapZce_api,
    jxzc_findDetailsFap_api,
    jxzc_initDownData_api, jxzc_mxdjbjcx_api , jxzc_savemxdjbj_api
  } from "@/api/iinvout";
	export default {
		name: '',
		components: {
			minhead
		},
		props: {
			initdata: {
				type: Object,
				default: () => ({})
			}
		},
		data: function() {
			return {
				searchdata: getdata().searchdata,
				searchlist: getdata().searchlist,
				searchdiag: false,
				outlist: [],
				headData: getdata().headData,
				tableData: [{}],
				shaidiag: false,
				disck: true,
				Count: 0,
				overlength: 0,
				Countlist: [{
						label: "汇总发票已抵扣税额",
						value: "¥0"
					},
					{
						label: "汇总本期转出税额",
						value: "¥0"
					},
				],
				sgdjdiag: false,
				headDatasgdj: getdata().headDatasgdj,
				pagination: getdata().pagination,
				nsrsbhData: getdata().nsrsbhData,
        tableDatasgdj:getdata().tableDatasgdj,
				zclxList: [],
				djdata: getdata().djdata,
				choosedjindex: null,
				updatedjindex: null,
        djdataitem: {
          suosq:this.initdata.suosq,
          zhuanclx:"",
          zhuancse: "",
          dengjsm:"",
          baoczt:"0"
        },
        taxtotal:"0",
        deleteIds:[]
			};
		},
		created() {
			this.init();
		},
		methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
			forchoosemove(index) {
				if (this.choosedjindex != index) {
					this.choosedjindex = index
				}
			},
			foraddup(index){
      let item = JSON.parse(JSON.stringify(this.djdataitem));
			this.djdata.splice(index,0,item);
			},
			foradddown(index){
        let item = JSON.parse(JSON.stringify(this.djdataitem));
				this.djdata.splice(index+1,0,item);
			},
			forremove(item,index){
        if (item.suosq != this.initdata.suosq){
           return;
        }
        if (item.id){
          this.deleteIds.push(item.id);  //删除的ids
        }
				this.djdata.splice(index,1);
        if (this.djdata.length <= 0){
          this.initDengjsm();
          return;
        }
        this.computedFapDengj();
			},
			forsureupdate(item,index){
        if (item.suosq != this.initdata.suosq){
          return;
        }
        if (item.dengjsm.length > 255){
          this.$message.info("登记说明不能超过255个字符");
          return;
        }
        if (!item.zhuanclx){
          this.$message.info("请选择转出类型");
          return;
        }
        if (!item.zhuancse){
          this.$message.info("请填写转出额");
          return;
        }
        item.baoczt = "2"; //保存状态 已保存
				item.updatetype=false;
				var newdata=JSON.parse(JSON.stringify(this.djdata))
				this.djdata=newdata
        this.computedFapDengj();
			},
			forupdatetype(item,index){
        if (item.suosq != this.initdata.suosq){
          return;
        }
        if(this.djdata.length > 1){
          var noBaoc = this.djdata.filter(e => e.baoczt == '1').length;
          if (noBaoc > 0){
            this.$message.info("请先保存上一条记录,再进行编辑");
            return;
          }
        }
        item.baoczt = "1"; //保存状态 编辑
				item.updatetype=true
				var newdata=JSON.parse(JSON.stringify(this.djdata))
				this.djdata=newdata
			},
			init() {
				jxzc_initDownData_api({}).then(res => {
					if (res.data.code != 1) {
						this.$message.error(res.data.msg)
					} else {
						this.nsrsbhData = res.data.data.nsrsbhList;
						this.zclxList = res.data.data.zclxList.map(item => {
							return {
								label: item.zclxName,
								value: item.id
							}
						})
						var newlist = this.searchlist.map(item => {
							if (item.prop == 'zhuanclx') {
								item.selectval = this.zclxList;
							}
							return item
						})
						this.searchlist = JSON.parse(JSON.stringify(newlist))
						this.getMxdjInfo();
					}
				})
			},

			//获取明细登记数据
			getMxdjInfo() {
        let params = this.searchdata;
        params.current = this.pagination.pageNum;
        params.size = this.pagination.pageSize;
        params.sort = "fapdm,faphm";
        params.order = "desc,desc";
        params.nsrsbh = this.initdata.nsrsbh;
        params.suosq = this.initdata.suosq;
				jxzc_findDetailsFap_api(params).then(res => {
					if (res.data.code == 1) {
						this.tableData = res.data.data.records;
						this.pagination.total = res.data.data.total;
						this.pagination.paginationkey++;
            this.jinyongpd();
					} else {
            this.$message.error(res.data.msg);
          }
				})
			},
      //按钮禁用判断
      jinyongpd(){
        this.tableData.forEach(res => {
          res.sfydata = (res.zhuancse && res.zhuancse != '0.00') ? true : false; //是否有转出数据
        })
      },
			submitSearch() {
				this.getMxdjInfo();
			},
			forUpdateSearch() {
				this.searchdiag = true
			},
			closeSearch() {
				this.searchdiag = false
			},
			saveChange(e) {
				this.searchdiag = false
			},
			confirmfilter(e) {
				this.headData = e.chooselist
				this.outlist = e.nochooselist
				this.shaidiag = false
			},
			closeshaidiag() {
				this.shaidiag = false
			},
			forback() {
				this.$emit("closesgdj", true)
			},
			formxdj(row) {
        if(!row.sfydata){
          return;
        }
        this.$showConfirm({
          message: "是否确认清空数据操作？"
        }).then(res => {
          if(res=="confirm") {
            this.clearFapZce(row);
          }
        })
			},
      //清空本期转出税额
			clearFapZce(row) {
				let params = {
					id: row.mpid,
					jxzcId: this.initdata.outId
				}
				jxzc_clearFapZce_api(params).then(res => {
					if (res.data.code == 1) {
						this.$message.success("清空成功")
            this.getMxdjInfo();
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
      //编辑显示查询
			forhzck(e) {
        jxzc_mxdjbjcx_api(e).then(res => {
          if (res.data.code == 1){
            let arr = new Array();
            arr[0] = res.data.data;
            this.tableDatasgdj = JSON.parse(JSON.stringify(arr));
            this.djdata = res.data.data.data;
            this.initDengjsm();
            this.deleteIds = [];
          } else {
            this.$message.error(res.data.msg)
          }
          this.sgdjdiag = true;
        })
      },
      //明细登记初始化一条数据
      initDengjsm(){
        this.computedFapDengj();
        let len = this.djdata.length;
        let item = JSON.parse(JSON.stringify(this.djdataitem));
        this.djdata[len] = item;
      },
			sizechange(e) {
				this.pagination.pageSize = e
				this.getMxdjInfo()
			},
			currentChange(e) {
				this.pagination.pageNum = e
				this.getMxdjInfo()
			},
      //明细登记弹窗返回
      forbackDj(){
        let bcsize = this.djdata.filter(item => item.baoczt == '2').length;
        let delIds = this.deleteIds.length;
        if (bcsize > 0 || delIds > 0){
          this.$showConfirm({
            message: "当前操作的值将不会保存,是否返回？"
          }).then(res => {
            if(res=="confirm") {
              this.sgdjdiag = false;
            }
          })
        } else {
          this.sgdjdiag = false;
        }
      },
      //明细登记弹窗保存
      saveDjData(){
        let isRight = this.djdata.some(item =>  item.baoczt && item.baoczt == '1' );
        if(isRight){
          this.$message.info("请先完成编辑,再进行保存");
          return;
        }
        let param_data = JSON.parse(JSON.stringify(this.djdata.filter(item => item.baoczt == "2")));
        if (param_data.length <= 0 && this.deleteIds.length <= 0){
          this.sgdjdiag = false;
          return;
        }
        let param = JSON.parse(JSON.stringify(this.tableDatasgdj[0]));
        param.outid = this.initdata.outId;
        param.data = param_data;
        param.deleteIds = this.deleteIds;
        param.suosq = this.initdata.suosq;
        this.saveMxdjApi(param);
      },
      //保存明细登记api
      saveMxdjApi(param){
        jxzc_savemxdjbj_api(param).then(res => {
          if (res.data.code == 1){
            this.$message.success("保存成功");
            this.sgdjdiag = false;
            this.getMxdjInfo();
          } else {
            this.$message.error(res.data.msg);
          }
        })
      },
      //选择行计算汇总
      selectChange(){
        this.computedFap();
      },
      //发票税额统计,和本期转出税额统计
      computedFap(){
        let selectval = this.$refs.tablebox.getSelectionval();
        this.Count = selectval.length;
        let sumDikse = 0.00;
        let sumZcShuie = 0.00;
        selectval.forEach(item => {
           let dikse = Math.floor(parseFloat(item.dikse?item.dikse:0) * 100);
           let bqzcse = Math.floor(parseFloat(item.zhuancse?item.zhuancse:0) * 100);
          sumDikse += dikse;
           sumZcShuie += bqzcse;
        })
        sumDikse = sumDikse / 100;
        sumZcShuie = sumZcShuie / 100;
        this.Countlist[0].value = "¥" + sumDikse;
        this.Countlist[1].value = "¥" + sumZcShuie;
      },
      //编辑明细登记汇总统计
      computedFapDengj(){
        let hjzhuancse = 0.00;
        this.djdata.forEach(item => {
          let zhuancse = Math.floor(parseFloat(item.zhuancse?item.zhuancse:0) * 100);
          hjzhuancse += zhuancse;
        })
        hjzhuancse =  hjzhuancse / 100;
        this.taxtotal = "¥" + hjzhuancse ;
      }
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>
